import React from "react";
import _ from "lodash";
import SimpleTooltip from "components/common/SimpleTooltip";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import TargetTableView from "components/ops-mgmt/account/cst-config/TargetTableView";

import {
  getMapValue,
  upaPriceToReadable,
} from "components/ops-mgmt/account/In2wKeyConvertHelper";
import { HARDCODE } from "constants/CustomTarget";
import { parseValueName } from "helpers/Utils";

import { buttonActionClassGray } from "helpers/StyleClass";

import { FaTimes } from "react-icons/fa";

class CustomSpecificKeyValueImportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // for TargetTableView
      searchKey: [],
      columns: [],
      optKey: [],
      optDefault: {},

      data: [],
      selectedIds: [],
    };

    this.handleConfirm = this.handleConfirm.bind(this);

    this.handleRemove = this.handleRemove.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
  }

  componentDidMount() {
    const { data, selected = [], keyName } = this.props;

    const optKey = [];
    const searchKey = ["id", "name", "displayName"];

    const parseData = _.map(data, (item) => {
      return {
        ...item,
        name: parseValueName(item.name, item.matchType),
      };
    });

    let result = [];
    let optDefault = {};
    let columns = [];

    if (keyName === HARDCODE.KEY16 || keyName === HARDCODE.KEY20) {
      const keyList = [];
      result = _.map(parseData, (item) => {
        const { readableName } = item;
        const result = {};
        _.keys(readableName).forEach((key) => {
          if (key === "groupInfo") {
            result.groupInfoType =
              readableName.groupInfo && readableName.groupInfo.type
                ? readableName.groupInfo.type
                : "--";
            result.groupInfoLayer =
              readableName.groupInfo && readableName.groupInfo.layer
                ? readableName.groupInfo.layer
                : "--";
          } else if (key === "timeSliceInfo") {
            result.timeSliceStart =
              readableName.timeSliceInfo &&
              !_.isNil(readableName.timeSliceInfo.startHour)
                ? readableName.timeSliceInfo.startHour
                : "--";
            result.timeSliceSpan =
              readableName.timeSliceInfo && readableName.timeSliceInfo.timeSpan
                ? readableName.timeSliceInfo.timeSpan
                : "--";
          } else {
            if (!keyList.includes(key)) keyList.push(key);
            result[key] = readableName[key].key;
          }
        });
        return {
          ...item,
          ...result,
        };
      });
      optKey.push(...keyList, "groupInfoType", "groupInfoLayer");

      columns = [
        { key: "id", label: "Id" },
        { key: "name", label: "Name" },
        ...keyList.map((key) => ({
          key: key,
          label: key,
        })),
        { key: "groupInfoType", label: "Type", class: "w-24" },
        { key: "groupInfoLayer", label: "Layer", class: "w-24" },
      ];

      const mapValue = getMapValue();
      optDefault = {
        ...mapValue.ivInfo,
        groupInfoType: mapValue.groupInfo.groupType,
        groupInfoLayer: mapValue.groupInfo.groupLayer,
      };

      if (keyName === HARDCODE.KEY20) {
        columns.push(
          { key: "timeSliceStart", label: "Start", class: "w-24" },
          { key: "timeSliceSpan", label: "Span", class: "w-24" },
        );

        optKey.push("timeSliceStart", "timeSliceSpan");

        optDefault = {
          ...optDefault,
          timeSliceStart: mapValue.timeSliceInfo.startHour,
          timeSliceSpan: mapValue.timeSliceInfo.timeSpan,
        };
      }

      searchKey.push(...keyList);
    } else if (keyName === HARDCODE.UPA_PRICE) {
      result = _.map(parseData, (item) => {
        const price = upaPriceToReadable(item.name);
        return {
          ...item,
          ori: price.original,
          price: price.price,
          group: price.group,
          subGroup: price.subGroup,
        };
      });

      columns = [
        { key: "id", label: "Id" },
        { key: "name", label: "Name" },
        { key: "price", label: "Price", class: "w-24" },
        { key: "group", label: "Group", class: "w-24" },
        {
          key: "subGroup",
          label: "Sub Group",
          class: "w-32",
          content: ({ subGroup }) => {
            return subGroup === "" ? "None" : subGroup;
          },
        },
      ];

      optKey.push("group", "subGroup", "price");
      optDefault = {
        group: ["All", "o"],
        subGroup: ["0", "1", "2", ""],
      };
    }

    this.setState({
      selectedIds: _.map(selected, (item) => item.id),
      data: result,
      optKey,
      columns,
      searchKey,
      optDefault,
    });
  }

  handleRemove(id) {
    const { selectedIds } = this.state;
    this.setState({
      selectedIds: selectedIds.filter((item) => item !== id),
    });
  }

  handleClearAll() {
    this.setState({
      selectedIds: [],
    });
  }

  handleConfirm() {
    const { selectedIds } = this.state;
    const { handleImport } = this.props;

    if (handleImport) {
      handleImport(selectedIds);
    }
  }

  render() {
    const { handleClose, keyName } = this.props;
    const {
      selectedIds,
      searchKey,

      data,
      columns,
      optKey,
      optDefault,
    } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        handleClose={handleClose}
        title={{
          label: "Select Value Ids for ",
          highlight: keyName,
        }}
        width="85%"
        customOverlayStyle={{ zIndex: 100 }}
      >
        <div className="relative mb-2 flex gap-2" style={{ height: "520px" }}>
          <div
            className="z-10 bg-white pr-2"
            style={{ width: "calc(100% - 14rem)" }}
          >
            <TargetTableView
              data={data}
              columns={columns}
              optKey={optKey}
              searchKey={searchKey}
              sortList={["id", "name"]}
              selected={selectedIds}
              optDefault={optDefault}
              onSelect={(list) => {
                this.setState({ selectedIds: list });
              }}
            ></TargetTableView>
          </div>

          <div
            className="absolute left-0 top-0 flex w-full overflow-y-auto"
            style={{
              height: "calc(100% - 0.5rem)",
            }}
          >
            <div className="z-20 ml-auto flex h-full flex-col gap-1">
              <div className="flex justify-end">
                <button
                  type="button"
                  className={buttonActionClassGray}
                  onClick={this.handleClearAll}
                >
                  Clear All
                </button>
              </div>

              <div
                className="rounded flex flex-1 flex-col items-end gap-1 bg-gray-100 p-2"
                style={{ width: "13rem" }}
              >
                {selectedIds.map((id) => {
                  const item = data.find((p) => p.id === id);

                  return (
                    <div className="w-48" key={id}>
                      <div className="rounded flex items-center gap-2 bg-blue-200 px-2 py-1">
                        <button
                          type="button"
                          className="text-xs text-gray-600 hover:text-blue-800"
                          onClick={() => this.handleRemove(id)}
                        >
                          <FaTimes></FaTimes>
                        </button>

                        <SimpleTooltip tooltipText={item.label} place="left">
                          <div className="text-sm leading-4 text-blue-800">
                            <div className="text-xs">
                              {item.label.split(" - ")[0]}
                            </div>

                            <div className="truncate w-40 font-medium">
                              {item.label.split(" - ")[1]}
                            </div>
                          </div>
                        </SimpleTooltip>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <ModalFooter
          confirmText={`Select ${`(${selectedIds.length})`}`}
          onCancel={handleClose}
          onConfirm={this.handleConfirm}
        ></ModalFooter>
      </ModalWrapper>
    );
  }
}

export default CustomSpecificKeyValueImportModal;
